"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildElementDescriptor = exports.ELEMENT_FINGERPRINT_VERSION = void 0;
const normalizeXpath_1 = require("./normalizeXpath");
/** No backfill: stored values outlive the recipe, so bump this whenever the descriptor changes. */
exports.ELEMENT_FINGERPRINT_VERSION = 'v1';
/**
 * `data-*` goes wholesale because its name does not say whether it holds
 * identity or state. axe-core does not escape quotes inside values, so a value
 * can leave a stray fragment behind, but always the same one for one element.
 */
const VOLATILE_ATTRIBUTE = /\s(?:class|style|id|xmlns|tabindex|selected|checked|disabled|data-[\w:.-]+|aria-(?:checked|selected|invalid|activedescendant|busy|disabled|expanded|grabbed|pressed|valuenow|current|hidden|controls|owns|labelledby|describedby))(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+))?(?=[\s/>])/gi;
/**
 * Once volatile attributes are stripped, text or one of these is all that
 * tells two elements apart. `type`, `role` and empty values only name an
 * element's kind: counting them merged a Guardian play button with a
 * Booking.com one.
 */
const IDENTIFYING_ATTRIBUTE = /\s(?:href|src|alt|title|aria-label|name|value|for|action|placeholder)\s*=\s*(?:"[^"]+"|'[^']+'|[^\s>"']+)/i;
/**
 * Excluding `<` from the body keeps this linear: `[^>]*` rescanned to the end
 * of the input from every unclosed `<`. The closing `>` is optional so a tag
 * axe-core truncated still counts as one.
 */
const TAG = /<[^<>]*>?/g;
/**
 * Exported so a mis-grouping can be read rather than re-derived.
 *
 * Position is only a last resort: measured on real scans, it split shared
 * chrome across pages and merged different items in one templated slot. For a
 * bare element the target carries the class names that tell components apart,
 * where the xpath of a templated page did not.
 */
const buildElementDescriptor = (input) => {
    const selector = locate(input);
    const markup = input.html ? stableMarkup(input.html) : '';
    const position = !input.html || isBare(markup) ? JSON.stringify(selector) : '';
    return formatDescriptor({ selector, markup, position });
};
exports.buildElementDescriptor = buildElementDescriptor;
/**
 * Only an empty target reaches the fallbacks: deduplication gives no
 * fingerprint to a node without one, but other callers may.
 */
const locate = ({ target, xpath, ancestry }) => {
    if (target.length > 0) {
        return target;
    }
    if (xpath) {
        return (0, normalizeXpath_1.normalizeXpath)(xpath);
    }
    return ancestry ?? target;
};
const formatDescriptor = ({ selector, markup, position }) => [
    `frames=${frameDepth(selector)}`,
    `markup=${markup}`,
    `position=${position}`
].join('\n');
/**
 * Frameworks write per-render markers into comments (Lit's `<!--?lit$…$-->`).
 * An unclosed comment is one axe-core truncated.
 */
const COMMENT = /<!--[\s\S]*?(?:-->|$)/g;
/** Attributes are stripped inside tags only, so text keeps words like "id". */
const stableMarkup = (html) => html
    .replace(COMMENT, '')
    .replace(TAG, tag => tag.replace(VOLATILE_ATTRIBUTE, ''))
    .replace(/\s+/g, ' ')
    .trim();
/** Typically a container axe-core truncated to its opening tag. */
const isBare = (markup) => markup.replace(TAG, '').trim() === '' && !IDENTIFYING_ATTRIBUTE.test(markup);
/**
 * Depth rather than the frame itself, so one component stays one group
 * wherever it is embedded. axe-core adds one `target` entry per frame level; a
 * shadow DOM path is nested inside a single entry, so it never counts.
 */
const frameDepth = (selector) => Array.isArray(selector) ? Math.max(selector.length - 1, 0) : 0;
//# sourceMappingURL=elementDescriptor.js.map